<script lang="ts">
  import NewAnalytics from './analytics/NewAnalytics.svelte';
  import Sidenav from './components/Sidenav.svelte';
  import Configurations from './configurations/Configurations.svelte';
  import FeatureToggle from './feature-toggle/FeatureToggle.svelte';
  import ManageUser from './manage-user/ManageUser.svelte';
  import {currentRoute} from './store';
  import type {NavItem} from './types';

  const navItems: NavItem[] = [
    {label: 'Manage User', href: '#manage-user', icon: 'fa-solid fa-user'},
    {label: 'Feature Toggle', href: '#feature-toggle', icon: 'fa-solid fa-toggle-on'},
    {label: 'Configurations', href: '#configurations', icon: 'fa-solid fa-gear'},
    {label: 'Analytics', href: '#analytics', icon: 'fa-solid fa-chart-line'}
  ];

  $: title = navItems.find(item => item.href === $currentRoute)?.label;
</script>

<div class="flex h-screen">
  <div class="w-64 border-r border-gray-200">
    <Sidenav {navItems} />
  </div>
  <div class="h-full flex-1 overflow-y-auto">
    <div>
      <div class="flex w-full items-center border-b border-gray-300 p-4" style="height: 83px">
        <h2 class="text-2xl font-bold text-sermon-base-600">{title}</h2>
      </div>
      {#if $currentRoute === '#manage-user'}
        <ManageUser />
      {:else if $currentRoute === '#feature-toggle'}
        <FeatureToggle />
      {:else if $currentRoute === '#analytics'}
        <NewAnalytics />
      {:else if $currentRoute === '#configurations'}
        <Configurations />
      {/if}
    </div>
  </div>
</div>
